export const tags = [
  "jnct-activity-reorder",
  "jnct-activity-reorder-content",
  "jnct-activity-reorder-column-concurrent",
  "jnct-activity-reorder-column-sort",
] as const;
